import React, { useEffect, useState } from 'react';
import { useForm } from '../../../../shared/hooks/form-hook';
// import { useHttpClient } from '../../../../shared/hooks/http-hook';
import Input from '../../../../shared/components/FormElements/input';
import ImageUpload from '../../../../shared/components/FormElements/imageUpload';
import { VALIDATOR_REQUIRE } from '../../../../shared/util/validators';
import { Button } from '@mui/material';
import { NavLink, useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';


import './UpdateNews.css';



const UpdateNews = () => {
    const  newsId  = useParams().newsId;
    const history = useHistory();
   
    const [isLoading, setIsLoading] = useState(false)
    const [isLoaded, setIsLoaded] = useState();

    const [formState, inputHandler, setFormData] = useForm( 
        {
            title: {
                value:'',
                isValid: false
            },
            content: {
                value: '',
                isValid: false
            }, 
            image: {
                value:'',
                isValid: true
            },
            url: {
                value:'',
                isValid: true
            }
       },
false
    
);
 

useEffect(() => {
    const fetchNews = async () => {
        setIsLoading(true)
        try{
          const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/news/${newsId}`);
          const responseData = await response.json();
          setIsLoaded(responseData.news);
          setFormData(
            {
                title:{
                    value: responseData.news.title,
                    isValid: true
                },
                content: {
                    value: responseData.news.content,
                    isValid: true
                }, 
                image: {
                    value: responseData.news.image ,
                    isValid: true
                },
                url: {
                    value: responseData.news.url ,
                    isValid: true
                }
            },
            true
        ); 
        } catch (err) {
            console.log(err.message)
        }
      
    }
   
    fetchNews();
}, [ newsId, setFormData])

   

    const submitHandler = async (event) => {
        event.preventDefault();

        try {
            const formData = new FormData();
            formData.append('title', formState.inputs.title.value);
            formData.append('content', formState.inputs.content.value);
            formData.append('url', formState.inputs.url.value);

            // Append image if a new one is uploaded
            if (formState.inputs.image.value instanceof File){
                formData.append('image', formState.inputs.image.value);
            }


             await fetch(`${process.env.REACT_APP_BACKEND_URL}/news/${newsId}`, {
                method: 'PATCH',
                body: formData,
                // headers: {
                //     'Content-Type': 'application/json'
                // }
            });
        } catch (err) {
            console.log(err.message)
        }

           
        
        // console.log(formState.inputs) // sending to backend
        history.push('/')
    }

    

    if(!isLoading){
        return<div> <h2>Loading...</h2> </div>
        

           
    }

    if(!isLoaded){
        return <div>Article not found!</div>
    }
return(

        <main className='update-form'>

            <NavLink to='/'><FontAwesomeIcon icon={faArrowLeft} className='font-controller-announce'/></NavLink>
            
            <h1>This is Edit page</h1>         
            <div className='update-form-container'>

           { isLoaded && (
            <form onSubmit={submitHandler} className='form-controllor'>
                <Input 
                    id='title'
                    element='input'
                    type='text'
                    label='Title'
                    autoComplete='off' 
                    errorText='Please enter a valid title'
                    validators={[VALIDATOR_REQUIRE()]}  
                    onInput={inputHandler}
                    initialValue={isLoaded.title}
                />
            
                <Input 
                    id='content'
                    element='textarea'
                    type='text'
                    label='Content'
                    autoComplete='off' 
                    validators={[VALIDATOR_REQUIRE()]} 
                    errorText='Please enter a valid title'
                    onInput={inputHandler}
                    initialValue={isLoaded.content}
                />
                <ImageUpload 
                  id='image'      
                  onInput={inputHandler}
                  initialValue={isLoaded.image}
                />

                <Input 
                    id='url'
                    element='input'
                    type='url'
                    label='Url'
                    autoComplete='off' 
                    errorText='Field is empty'
                    validators={[VALIDATOR_REQUIRE()]}  
                    onInput={inputHandler}
                    initialValue={isLoaded.url}
                />
                <Button type='submit' variant='contained' style={{marginTop: '20px'}}>Update</Button>
            </form>
             )} 
            </div>
        </main>
    )
}

export default UpdateNews;